<div class="credits-exhausted-popup pad-32 flex-centered-container-column gap-16-px text-center">
  <div class="credits-exhausted-popup__icon flex-centered-container border-radius-full insufficient-balance">
    <mat-icon>warning_amber</mat-icon>
  </div>

  <h2 class="no-margin text-black font-bold font-20 line-24">
    {{ dialogConfig.title }}
  </h2>

  <p class="no-margin no-data-text font-14">
    {{ dialogConfig.body }}
  </p>

  <ng-container *ngIf="plansEnabled">
    <button type="button" *ngIf="dialogConfig.show_upgrade"
      class="credits-exhausted-popup__btn full-width new-submit-button fg-white chamfer-xl font-bold font-14 flex-inline-centered-container gap-8-px"
      [disabled]="isBillingPortalBusy"x
      (click)="openBillingPortal(billingRoutes.Upgrade)">
      Upgrade plan
      <ng-container *ngIf="pendingTarget === billingRoutes.Upgrade; else upgradeIcon">
        <span class="fg-white credits-exhausted-popup__btn-spinner-wrap flex-inline-centered-container">
          <mat-spinner class="credits-exhausted-popup__btn-spinner" diameter="18" strokeWidth="2"></mat-spinner>
        </span>
      </ng-container>
      <ng-template #upgradeIcon>
        <mat-icon class="credits-exhausted-popup__btn-icon font-18">open_in_new</mat-icon>
      </ng-template>
    </button>
  
    <button type="button" *ngIf="dialogConfig.show_top_up"
      class="credits-exhausted-popup__btn full-width bg-white overview-card chamfer-xl font-bold font-14 text-black flex-inline-centered-container gap-8-px"
      [disabled]="isBillingPortalBusy" (click)="openBillingPortal(billingRoutes.TopUp)">
      Buy credit top-up
      <ng-container *ngIf="pendingTarget === billingRoutes.TopUp; else topupIcon">
        <span class="no-data-text credits-exhausted-popup__btn-spinner-wrap flex-inline-centered-container">
          <mat-spinner class="credits-exhausted-popup__btn-spinner" diameter="18" strokeWidth="2"></mat-spinner>
        </span>
      </ng-container>
      <ng-template #topupIcon>
        <mat-icon class="credits-exhausted-popup__btn-icon font-18 no-data-text">open_in_new</mat-icon>
      </ng-template>
    </button>
  </ng-container>
</div>